import { render } from "./DefaultLayout.vue?vue&type=template&id=19ec37cc&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=19ec37cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ec37cc"]])

export default __exports__